import { startCase } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import css from '../ListingPage.module.css';
import classNames from 'classnames';
import TooltipComponent from '../../../components/Tooltip/Tooltip';
import { HStack, Tag } from '@chakra-ui/react';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import SelfImprovementRoundedIcon from '@mui/icons-material/SelfImprovementRounded';
import DiamondRoundedIcon from '@mui/icons-material/DiamondRounded';
import NaturePeopleRoundedIcon from '@mui/icons-material/NaturePeopleRounded';
import Diversity1RoundedIcon from '@mui/icons-material/Diversity1Rounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import BatteryChargingFullRoundedIcon from '@mui/icons-material/BatteryChargingFullRounded';
import SellRoundedIcon from '@mui/icons-material/SellRounded';
import StairsRoundedIcon from '@mui/icons-material/StairsRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import SentimentVerySatisfiedRoundedIcon from '@mui/icons-material/SentimentVerySatisfiedRounded';

export const VIBES_TAGS = [
  {
    id: 'chic',
    label: 'Chic',
    colour: 'purple',
    descriptor: 'Trendy, stylish, and fashion-forward; where aesthetics meet sophistication',
    icon: <WhatshotIcon />,
    tagline: 'Styled & sophisticated',
  },
  {
    id: 'casual',
    label: 'Casual',
    colour: 'red',
    descriptor: 'A laid-back atmosphere with a relaxed, approachable vibe',
    icon: <SentimentVerySatisfiedRoundedIcon />,
    tagline: 'Easygoing & friendly',
  },
  {
    id: 'premium',
    label: 'Premium',
    colour: 'gray',
    descriptor: 'A refined and exclusive experience for those seeking a touch of luxury',
    icon: <DiamondRoundedIcon />,
    tagline: 'Treat yourself',
  },
  {
    id: 'value',
    label: 'Value',
    colour: 'cyan',
    descriptor:
      'Affordable yet quality-focused, delivering great experiences without the premium price',
    icon: <SellRoundedIcon />,
    tagline: 'Worth it',
  },
  {
    id: 'inclusive',
    label: 'Inclusive',
    colour: 'yellow',
    descriptor: 'A space designed to be welcoming and accessible to people with disabilities',
    icon: <Diversity1RoundedIcon />,
    tagline: 'Everyone welcome',
  },
  {
    id: 'beginner',
    label: 'Beginner',
    colour: 'green',
    descriptor: 'Tailored for newcomers, with approachable, beginner-friendly activities',
    icon: <StarRoundedIcon />,
    tagline: "You've got this",
  },
  {
    id: 'advanced',
    label: 'Advanced',
    colour: 'teal',
    descriptor: 'Designed for experienced folks, offering more intense, skill-focused sessions',
    icon: <StairsRoundedIcon />,
    tagline: 'Bring the burn',
  },
  {
    id: 'relaxed',
    label: 'Relaxed',
    colour: 'blue',
    descriptor: 'Calm, soothing, and perfect for unwinding in a tranquil setting',
    icon: <SelfImprovementRoundedIcon />,
    tagline: 'Slow it down',
  },
  {
    id: 'outdoors',
    label: 'Outdoors',
    colour: 'green',
    descriptor: 'A connection with nature, bringing activities outside for a refreshing experience',
    icon: <NaturePeopleRoundedIcon />,
    tagline: 'Take it outside',
  },
  {
    id: 'social',
    label: 'Social',
    colour: 'pink',
    descriptor:
      'A lively, interactive setting that fosters social connections and group activities',
    icon: <Diversity3RoundedIcon />,
    tagline: 'Find your people',
  },
  {
    id: 'energetic',
    label: 'Energetic',
    colour: 'orange',
    descriptor: 'High-intensity, upbeat, and perfect for those looking to push their limits',
    icon: <BatteryChargingFullRoundedIcon />,
    tagline: 'Break a sweat',
  },
];

const SectionVibeCheck = ({ publicData, isSection = false, isFirstCard = false, size = 'md' }) => {
  const { vibesTag: vibesTags = [] } = publicData;

  if (isEmpty(vibesTags)) {
    return <></>;
  }

  const selectedVibes = VIBES_TAGS.filter(vibe => vibesTags.includes(vibe.id));

  return (
    <HStack
      gap={'0.5rem'}
      className={classNames(css.vibeCheckTags, {
        [css.sectionVibeTags]: isSection,
      })}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {selectedVibes.map((tag, tagIndex) => {
        const isFirstVibeTagSpecial = isFirstCard && tagIndex === 0;
        const isSecondVibeTagSpecial = isFirstCard && tagIndex === 1;

        return (
          <TooltipComponent key={tag.id} content={tag.descriptor}>
            <Tag.Root
              className={
                isFirstVibeTagSpecial
                  ? css.specialTag
                  : isSecondVibeTagSpecial
                  ? css.specialTagSecond
                  : ''
              }
              size={size}
              colorPalette={tag.colour}
              variant={'subtle'}
              rounded={'3xl'}
            >
              <Tag.Label>{tag.label}</Tag.Label>
            </Tag.Root>
          </TooltipComponent>
        );
      })}
    </HStack>
  );
};

export default SectionVibeCheck;
